export const CustomOverlay = () => {
  return (
    <div className="fixed inset-0 z-10 h-full w-full shrink-0 bg-gray-500/50 py-2" />
  );
};
